import { render, staticRenderFns } from "./recycle3D.vue?vue&type=template&id=6a1b2550&scoped=true&"
import script from "./recycle3D.vue?vue&type=script&lang=js&"
export * from "./recycle3D.vue?vue&type=script&lang=js&"
import style0 from "./recycle3D.vue?vue&type=style&index=0&id=6a1b2550&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a1b2550",
  null
  
)

export default component.exports